var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlaystore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 56,
    viewBox: "0 0 203 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.342 56H7.54133C3.41159 56 0.0292969 52.8482 0.0292969 49V7C0.0292969 3.15175 3.41159 9.53674e-07 7.54133 9.53674e-07H195.342C199.472 9.53674e-07 202.854 3.15175 202.854 7V49C202.854 52.8482 199.472 56 195.342 56Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.342 1.12175C198.82 1.12175 201.65 3.759 201.65 7V49C201.65 52.241 198.82 54.8783 195.342 54.8783H7.54133C4.06326 54.8783 1.2331 52.241 1.2331 49V7C1.2331 3.759 4.06326 1.12175 7.54133 1.12175H195.342ZM195.342 9.53674e-07H7.54133C3.41159 9.53674e-07 0.0292969 3.15175 0.0292969 7V49C0.0292969 52.8482 3.41159 56 7.54133 56H195.342C199.472 56 202.854 52.8482 202.854 49V7C202.854 3.15175 199.472 9.53674e-07 195.342 9.53674e-07Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.707 10.5541C15.2657 10.9846 15.0103 11.6549 15.0103 12.5229V43.4839C15.0103 44.3519 15.2657 45.0221 15.707 45.4526L15.8159 45.5471L34.4345 28.2046V27.7951L15.8159 10.4526L15.707 10.5541Z",
    fill: "url(#paint0_linear_3888_90796)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6339 33.9885L34.4346 28.2048V27.7953L40.6414 22.0115L40.7804 22.0868L48.1309 25.984C50.2286 27.09 50.2286 28.91 48.1309 30.023L40.7804 33.9133L40.6339 33.9885Z",
    fill: "url(#paint1_linear_3888_90796)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7803 33.9132L34.4345 28L15.707 45.4527C16.4038 46.1352 17.54 46.2175 18.832 45.535L40.7803 33.9132Z",
    fill: "url(#paint2_linear_3888_90796)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7803 22.0868L18.832 10.465C17.54 9.78951 16.4038 9.87176 15.707 10.5543L34.4345 28L40.7803 22.0868Z",
    fill: "url(#paint3_linear_3888_90796)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2698 14.3411C71.2698 15.5101 70.8942 16.4463 70.1543 17.1446C69.3035 17.9723 68.1955 18.3888 66.8377 18.3888C65.54 18.3888 64.432 17.9653 63.523 17.1306C62.6122 16.2836 62.1577 15.2441 62.1577 13.9998C62.1577 12.7556 62.6122 11.7161 63.523 10.8761C64.432 10.0343 65.54 9.61084 66.8377 9.61084C67.4838 9.61084 68.0997 9.73509 68.6875 9.96609C69.2735 10.1988 69.7505 10.5138 70.0961 10.9023L69.311 11.6408C68.7082 10.9776 67.8875 10.6503 66.8377 10.6503C65.8912 10.6503 65.0705 10.9583 64.3738 11.5796C63.6845 12.2026 63.339 13.0093 63.339 13.9998C63.339 14.9903 63.6845 15.8041 64.3738 16.4271C65.0705 17.0413 65.8912 17.3563 66.8377 17.3563C67.8425 17.3563 68.6876 17.0413 69.3542 16.4201C69.7937 16.0088 70.0435 15.4418 70.1092 14.7173H66.8377V13.7058H71.2022C71.2548 13.9246 71.2698 14.1363 71.2698 14.3411Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1939 10.8342H74.0942V13.4942H77.7901V14.5057H74.0942V17.1657H78.1939V18.1965H72.9336V9.80347H78.1939V10.8342Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0805 18.1965H81.9199V10.8342H79.4053V9.80347H85.5971V10.8342H83.0805V18.1965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0781 18.1965V9.80347H91.2369V18.1965H90.0781Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M96.373 18.1965H95.2218V10.8342H92.6978V9.80347H98.897V10.8342H96.373V18.1965Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.619 17.1166C109.731 17.9653 108.631 18.3888 107.318 18.3888C105.998 18.3888 104.897 17.9653 104.009 17.1166C103.122 16.2696 102.681 15.2301 102.681 13.9998C102.681 12.7696 103.122 11.7301 104.009 10.8831C104.897 10.0343 105.998 9.61084 107.318 9.61084C108.623 9.61084 109.724 10.0343 110.612 10.8901C111.506 11.7441 111.947 12.7766 111.947 13.9998C111.947 15.2301 111.506 16.2696 110.619 17.1166ZM104.867 16.4131C105.536 17.0413 106.349 17.3563 107.318 17.3563C108.279 17.3563 109.1 17.0413 109.761 16.4131C110.428 15.7848 110.766 14.9781 110.766 13.9998C110.766 13.0216 110.428 12.2148 109.761 11.5866C109.1 10.9583 108.279 10.6433 107.318 10.6433C106.349 10.6433 105.536 10.9583 104.867 11.5866C104.2 12.2148 103.862 13.0216 103.862 13.9998C103.862 14.9781 104.2 15.7848 104.867 16.4131Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.576 18.1965V9.80347H114.984L119.364 16.331H119.414L119.364 14.7175V9.80347H120.522V18.1965H119.313L114.727 11.347H114.676L114.727 12.9675V18.1965H113.576Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.396 30.4535C98.8669 30.4535 95.9842 32.956 95.9842 36.4088C95.9842 39.8335 98.8669 42.3622 102.396 42.3622C105.932 42.3622 108.815 39.8335 108.815 36.4088C108.815 32.956 105.932 30.4535 102.396 30.4535ZM102.396 40.0172C100.459 40.0172 98.7937 38.528 98.7937 36.4088C98.7937 34.2615 100.459 32.7985 102.396 32.7985C104.332 32.7985 106.005 34.2615 106.005 36.4088C106.005 38.528 104.332 40.0172 102.396 40.0172ZM88.4064 30.4535C84.8701 30.4535 81.9949 32.956 81.9949 36.4088C81.9949 39.8335 84.8701 42.3622 88.4064 42.3622C91.9408 42.3622 94.8179 39.8335 94.8179 36.4088C94.8179 32.956 91.9408 30.4535 88.4064 30.4535ZM88.4064 40.0172C86.4683 40.0172 84.7969 38.528 84.7969 36.4088C84.7969 34.2615 86.4683 32.7985 88.4064 32.7985C90.3426 32.7985 92.0084 34.2615 92.0084 36.4088C92.0084 38.528 90.3426 40.0172 88.4064 40.0172ZM71.7597 32.2788V34.8093H78.2445C78.0548 36.2233 77.5478 37.2627 76.7703 37.9872C75.8238 38.8622 74.3495 39.8335 71.7597 39.8335C67.769 39.8335 64.644 36.8323 64.644 33.1135C64.644 29.3948 67.769 26.3935 71.7597 26.3935C73.9176 26.3935 75.4876 27.1793 76.6463 28.1978L78.56 26.4145C76.9393 24.9725 74.7833 23.8647 71.7597 23.8647C66.2872 23.8647 61.688 28.014 61.688 33.1135C61.688 38.213 66.2872 42.3622 71.7597 42.3622C74.7176 42.3622 76.9393 41.4592 78.6858 39.7652C80.4756 38.0975 81.0334 35.7525 81.0334 33.859C81.0334 33.271 80.9808 32.7302 80.8869 32.2788H71.7597ZM139.83 34.2405C139.302 32.9087 137.674 30.4535 134.358 30.4535C131.071 30.4535 128.335 32.8668 128.335 36.4088C128.335 39.7442 131.043 42.3622 134.673 42.3622C137.608 42.3622 139.302 40.6945 139.999 39.7232L137.821 38.3705C137.094 39.361 136.104 40.0172 134.673 40.0172C133.251 40.0172 132.232 39.41 131.578 38.213L140.125 34.9177L139.83 34.2405ZM131.116 36.2232C131.043 33.9272 133.03 32.7513 134.453 32.7513C135.569 32.7513 136.515 33.271 136.831 34.0147L131.116 36.2232ZM124.169 42H126.979V24.5H124.169V42ZM119.568 31.78H119.474C118.843 31.0835 117.639 30.4535 116.115 30.4535C112.914 30.4535 109.988 33.0715 109.988 36.428C109.988 39.7652 112.914 42.3622 116.115 42.3622C117.639 42.3622 118.843 41.727 119.474 41.0095H119.568V41.8635C119.568 44.1402 118.263 45.3635 116.158 45.3635C114.441 45.3635 113.376 44.2085 112.937 43.2372L110.494 44.1875C111.198 45.766 113.063 47.7085 116.158 47.7085C119.452 47.7085 122.231 45.9025 122.231 41.5082V30.8157H119.568V31.78ZM116.355 40.0172C114.419 40.0172 112.798 38.507 112.798 36.428C112.798 34.3297 114.419 32.7985 116.355 32.7985C118.263 32.7985 119.767 34.3297 119.767 36.428C119.767 38.507 118.263 40.0172 116.355 40.0172ZM152.984 24.5H146.264V42H149.066V35.3692H152.984C156.095 35.3692 159.147 33.271 159.147 29.9337C159.147 26.5982 156.088 24.5 152.984 24.5ZM153.057 32.935H149.066V26.9343H153.057C155.149 26.9343 156.343 28.553 156.343 29.9337C156.343 31.2882 155.149 32.935 153.057 32.935ZM170.378 30.4202C168.353 30.4202 166.248 31.2532 165.382 33.0995L167.869 34.0707C168.404 33.0995 169.388 32.7845 170.428 32.7845C171.882 32.7845 173.356 33.5983 173.379 35.035V35.2187C172.872 34.9457 171.786 34.5415 170.451 34.5415C167.773 34.5415 165.044 35.9153 165.044 38.479C165.044 40.824 167.238 42.3342 169.704 42.3342C171.589 42.3342 172.629 41.5415 173.283 40.6192H173.379V41.972H176.085V35.259C176.085 32.1563 173.599 30.4202 170.378 30.4202ZM170.04 40.0102C169.123 40.0102 167.846 39.5867 167.846 38.528C167.846 37.1735 169.439 36.6537 170.817 36.6537C172.051 36.6537 172.629 36.9075 173.379 37.2417C173.159 38.8622 171.662 40.0102 170.04 40.0102ZM185.945 30.8035L182.724 38.3897H182.628L179.298 30.8035H176.277L181.28 41.405L178.425 47.3042H181.353L189.062 30.8035H185.945ZM160.687 42H163.497V24.5H160.687V42Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3888_90796",
    x1: 32.7814,
    y1: 43.8063,
    x2: 9.34446,
    y2: 18.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3888_90796",
    x1: 50.8625,
    y1: 27.9981,
    x2: 14.5089,
    y2: 27.9981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3888_90796",
    x1: 37.3297,
    y1: 24.7854,
    x2: 5.54729,
    y2: -9.32178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3888_90796",
    x1: 10.9929,
    y1: 55.7533,
    x2: 25.1852,
    y2: 40.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaystore);
export default __webpack_public_path__ + "static/media/google-playstore.ba816a6e6be77b22ab192ba8b4c58f70.svg";
export { ForwardRef as ReactComponent };